import { Tag, Typography } from "antd"
import React from "react"

import { budgetFormat } from "../../../../../../../utils/number/budget-format.ts"
import type { FinancialTransactionItem } from "../../../../../types/project-finance.types.tsx"

interface Props {
  record: FinancialTransactionItem
  compact?: boolean
}

export const PaymentsSummary: React.FC<Props> = ({ record, compact }) => {
  const planned = parseFloat(record.value)
  const paid = parseFloat(record.exercised_value ?? "0")

  if (compact) {
    const compactText = (() => {
      if (paid < 0) return `Net refund ${budgetFormat(-paid)}`
      if (paid === 0) return "No payments yet"
      if (record.is_overpaid)
        return `Over-paid by ${budgetFormat(paid - planned)}`
      if (paid >= planned) return `Fully paid — ${budgetFormat(planned)}`
      return `Paid ${budgetFormat(paid)} of ${budgetFormat(planned)}`
    })()

    return (
      <Typography.Text type="secondary" className="text-xs whitespace-normal">
        {compactText}
      </Typography.Text>
    )
  }

  if (paid < 0) {
    return (
      <Typography.Text>
        <Tag color="volcano">Net refund {budgetFormat(-paid)}</Tag>{" "}
        {budgetFormat(planned)} planned
      </Typography.Text>
    )
  }
  if (paid === 0) {
    return (
      <Typography.Text>
        No payments yet — {budgetFormat(planned)} planned.
      </Typography.Text>
    )
  }
  if (record.is_overpaid) {
    return <Tag color="orange">Over-paid by {budgetFormat(paid - planned)}</Tag>
  }
  if (paid >= planned) {
    return <Tag color="green">Fully paid — {budgetFormat(planned)}</Tag>
  }
  const remaining = planned - paid
  return (
    <Typography.Text>
      Paid {budgetFormat(paid)} of {budgetFormat(planned)} —{" "}
      {budgetFormat(remaining)} remaining
    </Typography.Text>
  )
}
